module.exports = __webpack_public_path__ + "static/media/24x7Security.192e964f.png";